module.exports = __webpack_public_path__ + "img/watch-1.b7e28414.jpg";